import Vue from 'vue'
import gql from 'graphql-tag'
import Component from 'vue-class-component'

import { Carrier } from '@/modules/Carrier/interfaces/carrier'
import { CarrierProduct } from '@/modules/CarrierProduct/interfaces/carrier-product'
import CarrierForm from '@/modules/Carrier/components/CarrierForm.vue'
import CarrierProductForm from '@/modules/CarrierProduct/components/CarrierProductForm.vue'
import AppDialog from '@/components/AppDialog.vue'
import { SnackType } from '@/interfaces/snack'
import { showErrors, showNotification } from '@/utils/snack'
import { deleteCarrierProduct } from '@/modules/CarrierProduct/gql/carrier-product.gql'
import { deleteCarrier } from '@/modules/Carrier/gql/carrier.gql'

@Component({
  components: {
    CarrierForm,
    AppDialog,
    CarrierProductForm
  }
})
export default class CarrierDialog extends Vue {
  targetCarrier: Carrier | null = null
  targetCarrierProduct: CarrierProduct | null = null
  carrierDialog = {
    actionType: 'new',
    show: false,
    title: 'New Carrier',
    disable: false
  }

  deleteCarrierDialog = {
    show: false,
    title: 'Delete Carrier',
    text: ''
  }

  carrierProductDialog = {
    actionType: 'new',
    show: false,
    title: 'New Insurance Product',
    disable: false
  }

  deleteCarrierProductDialog = {
    show: false,
    title: 'Delete Insurance Product',
    text: ''
  }
  disableConfirm = false

  showCarrierEditDialog (e: Event, targetCarrier?: Carrier) {
    e.preventDefault()
    e.stopPropagation()
    let actionType = 'new'
    let title = 'New Carrier'
    if (targetCarrier) {
      this.targetCarrier = targetCarrier
      actionType = 'edit'
      title = 'Edit Progressive'
    }
    this.carrierDialog = {
      actionType,
      show: true,
      title,
      disable: false
    }
  }

  hideCarrierEditDialog () {
    this.targetCarrier = null
    this.carrierDialog = {
      actionType: 'new',
      show: false,
      title: 'New Carrier',
      disable: false
    }
  }

  async deleteCarrier (e: Event, carrier: Carrier) {
    e.preventDefault()
    e.stopPropagation()
    this.targetCarrier = carrier
    this.deleteCarrierDialog.show = true
  }

  async deleteCarrierPost () {
    if (!this.targetCarrier) {
      return
    }
    const { id } = this.targetCarrier
    this.deleteCarrierDialog.show = false
    try {
      const result = await this.$apollo.mutate({
        mutation: deleteCarrier,
        variables: {
          carrierId: Number(id)
        }
      })

      const res = result.data.deleteCarrier
      if (res) {
        showNotification({
          msg: 'Delete carrier successfully',
          type: SnackType.Success
        })
        this.targetCarrier = null
      }
    } catch (error) {
      showErrors(error.graphQLErrors)
    }
  }

  showCarrierProductEditDialog (e: Event, targetCarrierProduct?: CarrierProduct) {
    e.preventDefault()
    e.stopPropagation()
    let actionType = 'new'
    let title = 'New Insurance Product'
    if (targetCarrierProduct) {
      this.targetCarrierProduct = targetCarrierProduct
      actionType = 'edit'
      title = 'Edit Renter Policy'
    }
    this.carrierProductDialog = {
      actionType,
      show: true,
      title,
      disable: false
    }
  }

  hideCarrierProductEditDialog () {
    this.targetCarrierProduct = null
    this.carrierProductDialog = {
      actionType: 'new',
      show: false,
      title: 'New Insurance Product',
      disable: false
    }
  }

  async deleteCarrierProduct (e: Event, carrierProduct: CarrierProduct) {
    e.preventDefault()
    e.stopPropagation()
    this.targetCarrierProduct = carrierProduct
    this.deleteCarrierProductDialog.show = true
  }

  async deleteCarrierProductPost () {
    if (!this.targetCarrierProduct) {
      return
    }
    const { id } = this.targetCarrierProduct
    this.deleteCarrierProductDialog.show = false
    try {
      const result = await this.$apollo.mutate({
        mutation: deleteCarrierProduct,
        variables: {
          carrierProductId: Number(id)
        }
      })

      const res = result.data.deleteCarrierProduct
      if (res) {
        showNotification({
          msg: 'Delete insurance product successfully',
          type: SnackType.Success
        })
        this.targetCarrierProduct = null
      }
    } catch (error) {
      showErrors(error.graphQLErrors)
    }
  }
}
